// extracted by mini-css-extract-plugin
module.exports = {"wsaDropdown":"MoreOption_wsaDropdown__Yqhhf"};